module.exports = __webpack_public_path__ + "static/accr-gbca-ebc143c3edadabebf5946b3e88e817b9.svg";